/* eslint-disable */
//tslint:disable

export interface IOrderStatusSchema {
  /** Сообщение в банере **/
  description?: string | null;
  /** Статус записи **/
  type: EType;
}

export enum EType {
  /**  **/
  NoActive = 'noActive',
  /**  **/
  SignedUp = 'signedUp',
}
